module.exports = __webpack_public_path__ + "img/header-image.38d9bb09.svg";